import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { Observable, of } from "rxjs";
import { tap, map } from "rxjs/operators";
import { AccountService } from "../services/account.service";

export class InstitutionValidator {
  static createInfoChecker(
    accountService: AccountService,
    setInstitutionInfo: (info: { institutionExists: boolean, hasNonMaturity: boolean, hasPeerComparison: boolean }) => void
  ): AsyncValidatorFn {
    return (control: AbstractControl): Observable<null> => {
      if (!control.value) return of(null);

      return accountService.checkInstitution(control.value).pipe(
        tap(result => {
          const info = {
            institutionExists: !!(result as any)?.institutionExists,
            hasNonMaturity: !!(result as any)?.hasNonMaturity,
            hasPeerComparison: !!(result as any)?.hasPeerComparison,
          };
          setInstitutionInfo(info);
        }),
        map(() => null)
      );
    };
  }

}
